import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import {
  CreateRoomDisplayScreenSchema,
  type CreateRoomDisplayScreenDTO,
} from "@/modules/room-displays/domain/contracts/room-displays";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import {
  Button,
  FormCheckbox,
  FormInput,
  FormRoot,
  RHF,
  toast,
  zodResolver,
} from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { useCreateRoomDisplay } from "../api/queries";

export function RoomDisplayCreatePage() {
  const nav = useNavigate({ from: "/app/room-displays/new" });
  const create = useCreateRoomDisplay();

  const methods = RHF.useForm<CreateRoomDisplayScreenDTO>({
    resolver: zodResolver(CreateRoomDisplayScreenSchema),
    defaultValues: {
      slug: "",
      name: "",
      isActive: true,
    },
  });

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຈໍສະແດງຜົນ", to: "/app/room-displays" },
            { label: "ສ້າງ" },
          ]}
        />
      </Header>
      <Main>
        <div className="mb-4">
          <h1 className="font-semibold text-xl">ສ້າງຈໍສະແດງຜົນ</h1>
          <p className="text-muted-foreground text-sm">
            ຕາຕະລາງລວມທຸກຫ້ອງ · ຕັ້ງ poster ໄດ້ຫຼັງສ້າງ
          </p>
        </div>

        <div className="max-w-xl rounded-xl border bg-card p-6">
          <FormRoot
            methods={methods}
            onSubmit={async (values) => {
              try {
                const slug = values.slug.trim().toLowerCase();
                const created = await create.mutateAsync({
                  ...values,
                  slug,
                });
                toast.success("ສ້າງຈໍສຳເລັດ");
                void nav({
                  to: "/app/room-displays/$id",
                  params: { id: created.id },
                });
              } catch (e) {
                toast.error(
                  e instanceof Error ? e.message : "ສ້າງບໍ່ສຳເລັດ",
                );
              }
            }}
            className="flex flex-col gap-4"
          >
            <FormInput name="name" label="ຊື່" requiredMark />
            <FormInput
              name="slug"
              label="Slug"
              requiredMark
              hint="URL: /display/{slug} — a-z, 0-9, ຂີດກາງ"
            />
            <FormCheckbox name="isActive" label="ເປີດໃຊ້" />
            <div className="flex gap-2 pt-2">
              <Button type="submit" disabled={create.isPending}>
                ສ້າງ
              </Button>
              <Button
                type="button"
                variant="outline"
                onClick={() => nav({ to: "/app/room-displays" })}
              >
                ຍົກເລີກ
              </Button>
            </div>
          </FormRoot>
        </div>
      </Main>
    </>
  );
}
